import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuOpen: false,
    activeMenuFooter: false,
    activeFormFloating: false,
    isDesktop: null,
    activeBackdrop: false,
    token: localStorage.getItem('token') || null,
    isLoading: false,
    isLoadingApi: false,
    user: null,
    hash: localStorage.getItem('hash') || null,
  },
  getters: {
    hash(state) {
      return state.hash;
    },
    menuOpen(state) {
      return state.menuOpen;
    },
    activeMenuFooter(state) {
      return state.activeMenuFooter;
    },
    activeFormFloating(state) {
      return state.activeFormFloating;
    },
    isDesktop(state) {
      return state.isDesktop;
    },
    activeBackdrop(state) {
      return state.activeBackdrop;
    },
    userIsLogged(state){
      return state.token;
    },
    user: state => (state.user || JSON.parse(localStorage.getItem('user') || '{}')),
    isLoading(state) {
      return state.isLoading;
    },
    isLoadingApi(state) {
      return state.isLoadingApi;
    },
  },
  mutations: {
    setHash(state, value) {
      state.hash = value;
    },
    setMenuOpen(state, value){
      state.menuOpen = value;
    },
    setActiveMenuFooter(state, value){
      state.activeMenuFooter = value;
    },
    setActiveFormFloating(state, value){
      state.activeFormFloating = value;
    },
    setIsDesktop(state, value){
      state.isDesktop = value;
    },
    setActiveBackdrop(state, value){
      state.activeBackdrop = value;
      if (value){
        document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
      } else {
        document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
      }
    },
    setIsLoadingApi(state, value){
      state.isLoadingApi = value;
      if (value){
        document.getElementsByTagName('body')[0].classList.add('overflow-hidden-api');
      } else {
        document.getElementsByTagName('body')[0].classList.remove('overflow-hidden-api');
      }
    },
    setUserLogged(state, { token, user }) {
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      state.token = token;
      state.user = user;
    },
    setUserData(state, payload){
        localStorage.setItem('user', JSON.stringify(payload));
        state.user = payload;
    },
    setUserLoggedOut(state) {
      state.token = null
      state.user = {}
      localStorage.removeItem('token'); 
      localStorage.removeItem('user');
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },
  },
  actions: {
    setHash(context, value) {
      context.commit('setHash', value);
    },
    setIsLoading(context, value) {
      context.commit('setIsLoading', value);
    },
    setIsLoadingApi(context, value) {
      context.commit('setIsLoadingApi', value);
    },
    setActiveBackdrop(context, value){
      context.commit('setActiveBackdrop', value);
    },
    toggleFormFixed(context){
      if (context.getters.isDesktop){
        context.commit('setActiveFormFloating', !context.getters.activeFormFloating);
        if (context.getters.activeFormFloating){
          document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
          document.getElementsByClassName('backdrop_bar')[0].classList.remove('d-none');
        } else {
          document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
          document.getElementsByClassName('backdrop_bar')[0].classList.add('d-none');
        }
      }else {
        if (context.getters.activeMenuFooter){
          context.commit('setActiveMenuFooter', false);
        }else {
          context.commit('setActiveMenuFooter', true);
        }
      }
    },
    setMenuOpen(context, value) {
      context.commit('setActiveBackdrop', value);
      context.commit('setMenuOpen', value);
    },
    async accountLogin(context, user ) {
      return await axios.post('/api/v1/user/password', user)
        .then(response => { 
          context.commit('setUserLogged', { token: response.data.data.id, user: response.data.data })  
          return this.dispatch('getUser');
        })
        .catch(error => {
          return error;
        })
    },

    async setUserLoggedIn(context, { token, user }) {
      context.commit('setUserLogged', { token: token, user: user })  
      return await this.dispatch('getUser');
    },

    async getUser(context) {        
      return await axios.post('/api/v1/user/getUser', {id: this.state.token} )
        .then(response => { 
          if (response.data.success == true){
            context.commit('setUserData', response.data.data)
            return response;
          } else {
            context.commit('setUserLoggedOut')
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push('/home');
            return response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          context.commit('setUserLoggedOut')
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          this.$router.push('/home');
          return 'Usuário não encontrado.'
        })
    },
    accountLogout({ commit }) {
      commit('setUserLoggedOut')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
    async accountRegister(context, user ) {
      return await axios.post('/api/v1/user/register', user)
        .then(response => { 
          if (response.data && response.data.success){
            context.commit('setHash', response.data.data.hash);
            localStorage.setItem('hash', response.data.data.hash);
            return response;
          } else {
            return response;
          }
        })
        .catch(error => {
          return error;
        })
    },

  },
  modules: {
  }
})
